const generateSrcset = (image, widths = []) => {
  const url = new URL(image.src);
  return widths
    .filter((width) => width <= image.width)
    .map((width) => {
      url.searchParams.set('width', width.toString());
      return `${url.href} ${width}w`;
    })
    .join(', ');
};

const createImageElement = (featuredMedia, className, sizes, alt) => {
  const previewImage = featuredMedia.preview_image;
  const image = new Image(previewImage.width, previewImage.height);
  image.className = className;
  image.alt = featuredMedia.alt || alt;
  image.sizes = sizes;
  image.src = previewImage.src;
  image.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  image.loading = 'lazy';
  return image;
};

const updateCardVariantInputs = (wrapper, variantId) => {
  if (!variantId) return;

  wrapper.querySelectorAll('input[name="id"]').forEach((input) => {
    input.value = variantId;
  });
};

const swapCardImage = (wrapper, nextImage) => {
  const firstImage = wrapper.querySelector('.media--first');
  const secondImage = wrapper.querySelector('.media--second');
  if (!firstImage || !nextImage) return;

  const currentPath = new URL(firstImage.src, window.location.origin).pathname;
  const nextPath = new URL(nextImage.src, window.location.origin).pathname;
  if (currentPath === nextPath) return;

  let promotedSecond = false;
  if (secondImage && new URL(secondImage.src, window.location.origin).pathname === nextPath) {
    firstImage.remove();
    secondImage.classList.remove('media--second');
    secondImage.classList.add('media--first');
    promotedSecond = true;
  }

  if (!promotedSecond) {
    firstImage.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      easing: 'ease-in',
      fill: 'forwards',
    });

    setTimeout(() => {
      firstImage.parentNode.replaceChild(nextImage, firstImage);
      nextImage.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 200,
        easing: 'ease-in',
        fill: 'forwards',
      });
      if (secondImage) secondImage.remove();
    }, 200);
  }
};

const createImageFromUrl = (imageUrl, className, sizes, alt) => {
  const image = new Image();
  image.className = className;
  image.alt = alt || '';
  image.sizes = sizes || '';
  image.src = imageUrl;
  image.loading = 'lazy';
  return image;
};

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
      if (input.dataset.swatchBound === 'true') return;
      input.dataset.swatchBound = 'true';

      input.addEventListener('change', (event) => {
        const target = event.currentTarget;
        if (!target.checked) return;

        const firstImage = wrapper.querySelector('.media--first');
        const productHandle = wrapper.dataset.product;
        const variantId = target.dataset.variantId;
        const imageUrl = target.dataset.variantImageUrl;
        const overlayLink = wrapper.querySelector('.js-color-swatches-link');

        if (overlayLink && target.dataset.variantLink) {
          overlayLink.setAttribute('href', target.dataset.variantLink);
        }

        updateCardVariantInputs(wrapper, variantId);

        const addToCartButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
        if (addToCartButton) {
          addToCartButton.setAttribute('aria-disabled', 'false');
          const buttonLabel = addToCartButton.querySelector('span');
          if (buttonLabel) buttonLabel.classList.remove('hidden');
          const soldOutMessage = addToCartButton.querySelector('.sold-out-message');
          if (soldOutMessage) soldOutMessage.classList.add('hidden');
        }

        if (!firstImage) return;

        if (imageUrl) {
          swapCardImage(
            wrapper,
            createImageFromUrl(imageUrl, firstImage.className, firstImage.sizes, target.dataset.variantAlt)
          );
          return;
        }

        const colorValue = target.value;
        const productUrl = `${window.Shopify.routes.root}products/${productHandle}.js`;

        fetch(productUrl)
          .then((response) => {
            if (response.ok) return response.json();
            throw new Error('Network response was not ok');
          })
          .then((product) => {
            const variant = product.variants.find(
              (item) => item.featured_media != null && item.options.includes(colorValue)
            );
            if (!variant) return;

            swapCardImage(
              wrapper,
              createImageElement(variant.featured_media, firstImage.className, firstImage.sizes, product.title)
            );
          })
          .catch((error) => {
            console.error('There was a problem with the fetch operation:', error);
          });
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();
  document.addEventListener('shopify:section:load', () => {
    checkSwatches();
  });
}

colorSwatches();
